import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { NoAnalyticsDataInfo } from './NoAnalyticsDataInfo';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

const StyledContainer = styled(Box)(() => ({
    backgroundColor: Palette.white,
    borderRadius: '16px',
    padding: '40px 40px 30px',
    marginTop: '32px',
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        padding: '24px 24px 15px',
        marginTop: '20px',
    },
    '& .MuiTypography-h6': {
        lineHeight: '24px',
    },
    '&.service-closed-count-wrapper': {
        marginTop: '0 !important',
    },
}));

const StyledCard = styled(Box)(() => ({
    '& .analytics-chart-subtitle': {
        marginTop: '11px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            marginTop: '12px',
        },
    },
    '& .analytics-chart-subtitle + .analytics-chart-subtitle': {
        marginTop: '0',
        borderTop: 'none',
    },
    '& .analytics-chart-subtitle:last-of-type': {
        borderBottom: 'none',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            borderBottom: `2px solid ${Palette.gray.gray75}`,
        },
    },
}));

const StyledContent = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: '43px',
    [`@media (max-width: ${breakpoints.values.xl}px)`]: {
        gap: '4px',
    },
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        flexDirection: 'column',
    },
    '&.service-closed-count-parent': {
        display: 'block',
    },
}));

const StyledStatsBox = styled(Box)(() => ({
    width: '100%',
    maxWidth: '240px',
    [`@media (max-width: ${breakpoints.values.xl}px)`]: {
        maxWidth: '200px',
    },
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        maxWidth: '100%',
    },
    '&.product-count-analytics': {
        '& .MuiStack-root': {
            marginBottom: '0px !important',
        },
    },
}));

const StyledChartBox = styled(Box, {
    shouldForwardProp: prop => prop !== 'isEmpty' && prop !== 'barHeight',
})(({ isEmpty, barHeight }) => ({
    height: barHeight ? `${barHeight}px` : '272px',
    width: '100%',
    ...(isEmpty && {
        '& .recharts-yAxis': {
            '& .recharts-cartesian-axis-tick': {
                display: 'none',
            },
        },
    }),
    '&.chart-empty': {
        [`@media (max-width: ${breakpoints.values.sm}px)`]: {
            height: '120px !important',
            marginTop: '20px',
        },
        '& .recharts-responsive-container': {
            [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                display: 'none',
            },
        },
    },
    [`@media (max-width: ${breakpoints.values.md}px)`]: {
        height: barHeight ? `${barHeight}px` : '210px',
        marginTop: '30px',
    },
}));

export const ChartAnalyticsCard = ({ stats, chart, data, dataKey, barHeight, className = '' }) => {
    const avg = data.map(d => d[dataKey]).reduce((a, b) => a + b, 0) / data.length;
    const isEmpty = avg === 0 || data.length === 0;
    return (
        <StyledContainer className={`${className}-wrapper`}>
            <StyledCard>
                <StyledContent className={`${className}-parent`}>
                    <StyledStatsBox className={className}>{stats}</StyledStatsBox>
                    <StyledChartBox position='relative' isEmpty={isEmpty} barHeight={barHeight} className={isEmpty ? 'chart-empty' : ''}>
                        {isEmpty && <NoAnalyticsDataInfo />}
                        {chart}
                    </StyledChartBox>
                </StyledContent>
            </StyledCard>
        </StyledContainer>
    );
};
